import { render, staticRenderFns } from "./EarnUserGallery.vue?vue&type=template&id=1a15c7e5&scoped=true&"
import script from "./EarnUserGallery.vue?vue&type=script&lang=ts&"
export * from "./EarnUserGallery.vue?vue&type=script&lang=ts&"
import style0 from "./EarnUserGallery.vue?vue&type=style&index=0&id=1a15c7e5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a15c7e5",
  null
  
)

export default component.exports